import styled from 'styled-components';

export const Wrapper = styled.section`
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 24px;
    margin-bottom: 24px;
    align-items: center;
`
export const AdBannerWrapper = styled.section(
    props => `
    width: 120rem;
    height: 9rem;
    border-radius: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url('');
    position: relative;
    cursor:pointer;

    @media screen and (max-width:768px){
        width: 34.4rem;
        height: 5.2rem;
        justify-content: space-between;
    }
`,
);

export const TextWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center
`
export const HashText = styled.span`
    font-size: 3rem;
    font-weight: bold;
    color: white
`
export const SubText = styled.span`
    font-size: 2rem ;
    color: white;
    padding-left: 1rem;
    padding-top: 0.5rem;
`
export const ExploreBtn = styled.button`
    outline: 0;
    border: 0;
    padding: 1rem 2rem;
    font-size: 1.4rem;
    color: #009087;
    border-radius: 2rem;
    font-weight: bold
`
export const AdTag = styled.span`
    background: black;
    position: absolute;
    left: 0.5rem;
    bottom: 0.5rem;
    color: white;
    font-size: 1.2rem;
    font-weight: bold;
    padding: 0.2rem 0.5rem;
    border-radius: 0.5rem;
`
